import api from './api'

// In-memory cache for loadAllLayers to avoid redundant API calls during map init
let _layersCache = null
let _layersCacheTime = 0
const LAYERS_CACHE_TTL = 30000 // 30 seconds

export const uploadRaster = async (raster, config = {}) => {
  try {
    return await api.post('/raster/Add', raster, config)
  } catch (err) {
    console.error('Error uploading raster:', err)
    throw err
  }
}

//get all rasters
export const getAllRasters = async id => {
  try {
    const response = await api.get(`/raster/rasters/${id}`)
    return response.data
  } catch (err) {
    console.error('Error:', err)
    throw err // Rethrow the error so it can be caught and handled appropriately in the calling function
  }
}

export const deleteRaster = async id => {
  try {
    return await api.delete(`/raster/delete/${id}`)
  } catch (err) {
    console.log('err')
  }
}

export const loadAllLayers = async () => {
  const now = Date.now()
  if (_layersCache && now - _layersCacheTime < LAYERS_CACHE_TTL) {
    return _layersCache
  }

  try {
    const resortId = JSON.parse(localStorage.getItem('user'))
    const resort = resortId.user.resort_id

    const response = await api.get(`/raster/all-layer-info`, {
      params: {
        resortId: resort,
      },
    })

    _layersCache = response.data
    _layersCacheTime = Date.now()
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const invalidateLayersCache = () => {
  _layersCache = null
  _layersCacheTime = 0
}

// Défaut TiTiler pour tout le site (geoserverinfos.titiler_style). Droit `lidar:upload`.
export const updateLayerTitilerStyle = async (layerId, body) => {
  const response = await api.put(`/raster/layer/${layerId}/titiler-style`, body)
  return response.data
}

export const getLatestLayer = async () => {
  try {
    // Récupérer l'identifiant du site de l'utilisateur connecté depuis le local storage
    const resortId = JSON.parse(localStorage.getItem('user'))
    const resort = resortId.user.resort_id

    const response = await api.get(`/raster/latest`, {
      params: {
        resortId: resort,
      },
    })

    return response.data // Retourner les données de la réponse
  } catch (err) {
    console.error(err)
    throw err
  }
}

/** @param {'tif' | 'las'} format */
export const downloadLayer = (id, format = 'tif') => {
  const baseUrl = import.meta.env.VITE_URL || ''
  const apiBase = baseUrl.replace(/\/$/, '')
  const q = format === 'tif' ? '' : `?format=${encodeURIComponent(format)}`
  return `${apiBase}/raster/download/${id}${q}`
}

/** verifie si le fichier existe avant d’ouvrir un nouvel onglet pour ne pas afficherune page d’erreur JSON */
export const checkDownloadAvailability = async (id, format = 'tif') => {
  const response = await api.get(`/raster/download-check/${id}`, {
    params: { format },
  })
  return response.data
}
